module.exports = '<svg width="40" height="32" viewBox="0 0 40 32"><path d="M39.914 22.21l-3.722-8.684V2c0-1.106-1.77-2-2.832-2H6.414C5.352 0 4.192.894 4.192 2v11.528l-4.03 8.684C-.314 23.2.308 24 1.376 24h2.816v6c0 1.106 1.16 2 2.222 2H33.36c1.062 0 2.832-.894 2.832-2v-6h2.206c1.062 0 1.994-.8 1.516-1.79zM5.678 20l2.514-5.528V4h24v10.472L34.096 20H5.678zM20.952 6.308c-.424-.444-1.114-.39-1.538.052l-4.986 4.738c-.426.444-.284.902.318.902h3.446v4.938c0 .552.436 1.062.99 1.062h2c.552 0 1.01-.51 1.01-1.062V12h3.428c.602 0 .744-.43.318-.876l-4.986-4.816z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/fold-up-1.js
// module id = 1153
// module chunks = 14